module.exports = __webpack_public_path__ + "static/media/Illustration_Professional-1.2885d3d6.svg";